//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ArticlesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetArticlesQueryParameters = {
  lieferant?: string | null | undefined ;
  partNumberFrom?: string | null | undefined ;
  partNumberTo?: string | null | undefined ;
  supplierPartNumberFrom?: string | null | undefined ;
  supplierPartNumberTo?: string | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type PatchArticlesQueryParameters = {
  id: string ;
}

export function getUrl(lieferant?: string | null | undefined, partNumberFrom?: string | null | undefined, partNumberTo?: string | null | undefined, supplierPartNumberFrom?: string | null | undefined, supplierPartNumberTo?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/articles?";
if (lieferant !== undefined && lieferant !== null)
    url_ += "Lieferant=" + encodeURIComponent("" + lieferant) + "&";
if (partNumberFrom !== undefined && partNumberFrom !== null)
    url_ += "PartNumberFrom=" + encodeURIComponent("" + partNumberFrom) + "&";
if (partNumberTo !== undefined && partNumberTo !== null)
    url_ += "PartNumberTo=" + encodeURIComponent("" + partNumberTo) + "&";
if (supplierPartNumberFrom !== undefined && supplierPartNumberFrom !== null)
    url_ += "SupplierPartNumberFrom=" + encodeURIComponent("" + supplierPartNumberFrom) + "&";
if (supplierPartNumberTo !== undefined && supplierPartNumberTo !== null)
    url_ += "SupplierPartNumberTo=" + encodeURIComponent("" + supplierPartNumberTo) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.AbasExecuteResponse, unknown, Types.AbasExecuteResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AbasExecuteResponse, unknown, Types.AbasExecuteResponse>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetArticlesQueryParameters): QueryKey;
export function getQueryKey(lieferant?: string | null | undefined, partNumberFrom?: string | null | undefined, partNumberTo?: string | null | undefined, supplierPartNumberFrom?: string | null | undefined, supplierPartNumberTo?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { lieferant, partNumberFrom, partNumberTo, supplierPartNumberFrom, supplierPartNumberTo, offset, limit, sortBy, sortOrder,  } = params[0] as GetArticlesQueryParameters;

    return trimArrayEnd([
        'ArticlesClient',
        'get',
        lieferant as any,
        partNumberFrom as any,
        partNumberTo as any,
        supplierPartNumberFrom as any,
        supplierPartNumberTo as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'ArticlesClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as string | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as string | null | undefined,       context.queryKey[10] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.AbasExecuteResponse, TError = unknown>(dto: GetArticlesQueryParameters, options?: Omit<UseQueryOptions<Types.AbasExecuteResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param lieferant (optional) lieferant
 * @param partNumberFrom (optional) artvonnum
 * @param partNumberTo (optional) artbisnum
 * @param supplierPartNumberFrom (optional) kytvonartnrlief
 * @param supplierPartNumberTo (optional) kytbisartnrlief
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.AbasExecuteResponse, TError = unknown>(lieferant?: string | null | undefined, partNumberFrom?: string | null | undefined, partNumberTo?: string | null | undefined, supplierPartNumberFrom?: string | null | undefined, supplierPartNumberTo?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.AbasExecuteResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.AbasExecuteResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AbasExecuteResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let lieferant: any = undefined;
  let partNumberFrom: any = undefined;
  let partNumberTo: any = undefined;
  let supplierPartNumberFrom: any = undefined;
  let supplierPartNumberTo: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ lieferant, partNumberFrom, partNumberTo, supplierPartNumberFrom, supplierPartNumberTo, offset, limit, sortBy, sortOrder,  } = params[0] as GetArticlesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [lieferant, partNumberFrom, partNumberTo, supplierPartNumberFrom, supplierPartNumberTo, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AbasExecuteResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(lieferant, partNumberFrom, partNumberTo, supplierPartNumberFrom, supplierPartNumberTo, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.AbasExecuteResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param lieferant (optional) lieferant
 * @param partNumberFrom (optional) artvonnum
 * @param partNumberTo (optional) artbisnum
 * @param supplierPartNumberFrom (optional) kytvonartnrlief
 * @param supplierPartNumberTo (optional) kytbisartnrlief
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.AbasExecuteResponse | undefined) => Types.AbasExecuteResponse, lieferant?: string | null | undefined, partNumberFrom?: string | null | undefined, partNumberTo?: string | null | undefined, supplierPartNumberFrom?: string | null | undefined, supplierPartNumberTo?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(lieferant, partNumberFrom, partNumberTo, supplierPartNumberFrom, supplierPartNumberTo, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets data.
 * @param lieferant (optional) lieferant
 * @param partNumberFrom (optional) artvonnum
 * @param partNumberTo (optional) artbisnum
 * @param supplierPartNumberFrom (optional) kytvonartnrlief
 * @param supplierPartNumberTo (optional) kytbisartnrlief
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AbasExecuteResponse | undefined) => Types.AbasExecuteResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/articles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'ArticlesClient',
      'patch',
      id as any,
    ]);
}

/**
 * Partially updates resource by id.
 */
export function usePatchMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, { [key: string]: any; }, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, { [key: string]: any; }, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (patchDto: { [key: string]: any; }) => Client.patch(id, patchDto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchArticlesQueryParameters & {
  patchDto: { [key: string]: any; };
}

/**
 * Partially updates resource by id.
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchArticlesQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.patchDto),
  mutationKey: key,
});
}